import { Refresh } from '@lichtblick/icons';
import { TextVariants } from '@lichtblick/theme';

import { Container, TextContainer } from './ErrorMessage.styles';
import { Error } from './images/Error';

import { Button } from '../Button';
import { Text } from '../Text';

type ErrorMessageProps = {
  buttonLabel?: string;
  description?: string;
  onClick?: () => void;
  title: string;
};

export const ErrorMessage = ({ buttonLabel, description, onClick, title }: ErrorMessageProps) => {
  return (
    <Container>
      <Error />

      <TextContainer>
        {title && <Text $variant={TextVariants.header.m}>{title}</Text>}
        {description && <Text $variant={TextVariants.body.l}>{description}</Text>}
      </TextContainer>
      {buttonLabel && <Button icon={<Refresh />} label={buttonLabel} onClick={onClick} />}
    </Container>
  );
};
